module.exports = __webpack_public_path__ + "img/img-1.566b7714.png";